/** Declaration of Non-BO 문서 provide/inject 컨텍스트. */
import type { InjectionKey, Ref } from 'vue';
import type { DeclarationNonBoFieldType } from './declarationNonBoFields';
import type { SignerEntry } from '@/features/AI-documents/types/docGen.types';

export interface DeclarationNonBoDocContext {
  valueOf: (key: string) => string;
  labelOf: (key: string) => string;
  typeOf: (key: string) => DeclarationNonBoFieldType;
  activeKey: Ref<string>;
  activate: (key: string) => void;
  setFieldValue: (key: string, val: string) => void;
  openAddress: (key: string) => void;
  entityCd: Ref<string>;
  signersOf: (varKey: string) => SignerEntry[];
  setSigners: (varKey: string, list: SignerEntry[]) => void;
  pendingPickValue: Ref<string>;
  placePick: (key: string) => boolean;
}

export const DECLARATION_NON_BO_DOC_CTX: InjectionKey<DeclarationNonBoDocContext> = Symbol('declarationNonBoDocCtx');
